(() => {
  const init = (scope = document) => {
    scope.querySelectorAll('[data-namtek-reveal]').forEach((visual) => {
      if (visual.dataset.revealReady === 'true') return;
      const story = visual.closest('.namtek-story');
      const button = story?.querySelector('[data-namtek-reveal-button]');
      const shop = story?.querySelector('[data-namtek-shop-button]');
      if (!story || !button || !shop) return;
      visual.dataset.revealReady = 'true';

      button.addEventListener('click', () => {
        if (story.classList.contains('is-revealed')) return;
        story.classList.add('is-revealed');
        button.setAttribute('aria-expanded', 'true');
        button.disabled = true;

        setTimeout(() => {
          button.hidden = true;
          shop.hidden = false;
          requestAnimationFrame(() => shop.classList.add('is-entering'));
          shop.focus({ preventScroll: true });
        }, 900);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => init(), { once: true });
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
